import script from "./AssetsBulkUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsBulkUploader.vue?vue&type=script&setup=true&lang=js"

import "./AssetsBulkUploader.vue?vue&type=style&index=0&id=1d24ec06&lang=css"

const __exports__ = script;

export default __exports__